/**
 *｜--------------------------------------------------------------------------
 *｜Author     : 1045998323@qq.com
 *｜Class      : storeBox.js
 *｜CreateTime ：2024/9/10 10:39
 *｜Notes      : 类说明
 *｜--------------------------------------------------------------------------
 */
import StoreDetail from "./StoreDetail";
import StoreList from "./StoreList";
import React, {useEffect} from 'react';
import {useGroupDeviceState,useGroupDeviceDispatch} from './Provider';
const StoreBox = () => {
  const { showDetail,currentCompanyId } = useGroupDeviceState();
  const { setShowDetail}  = useGroupDeviceDispatch()
  useEffect(()=>{
    setShowDetail(false)
  },[currentCompanyId])
  return (
    <>
      {showDetail ? <StoreDetail/> : <StoreList />}
    </>
  )

}

export default StoreBox;
